import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/UI/Icon';
import Button from '..';

import './index.css';

const IconButton = ({
  className, icon, onClick, test,
}) => (
  <Button className={`IconButton ${className}`} onClick={onClick} test={test}>
    <Icon icon={icon} />
  </Button>
);

IconButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  test: PropTypes.string,
};

IconButton.defaultProps = {
  className: '',
  test: '',
};

export default IconButton;
